import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useAuthStore from '../../../store/authStore';
import { ChevronRightIcon } from '@heroicons/react/outline';

interface ContractAcknowledgmentPageProps {
  contractTitle: string;
  lawyerName: string;
}

const ContractAcknowledgmentPage: React.FC = () => {
  const { contractId } = useParams<{ contractId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { userData } = useAuthStore();
  const userName = userData?.fullName || 'العميل';
  
  const action = searchParams.get('action') as 'approve' | 'reject' | null;
  const contractTitle = searchParams.get('title') || 'هذا العقد';
  const lawyerName = searchParams.get('lawyerName') || 'علي الزهراني';

  const handleBack = () => {
    navigate(-1);
  };

  const handleAgree = () => {
    if (!contractId) return;
    navigate(`/contracts/${contractId}/verify-otp?action=${action}`);
  };

  // Redirect if action is invalid
  if (!contractId || !action || !['approve', 'reject'].includes(action)) {
    navigate('/contracts');
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6 font-tajawal">
      {/* Header */}
      <div className="flex items-center mb-8">
        <button 
          onClick={handleBack}
          className="p-2 -mr-2"
        >
          <ChevronRightIcon className="h-6 w-6 text-gray-700" />
        </button>
        <h2 className="text-2xl font-bold text-gray-900 flex-1  mr-2">
          إقرار وتعهد
        </h2>
      </div>

      {/* Contract Info */}
      <div className="bg-white rounded-2xl p-5 shadow-sm mb-6">
        <h2 className="text-lg font-bold text-gray-900 mb-2">{contractTitle}</h2>
        <p className="text-sm text-gray-500">مع المحامي/ {lawyerName}</p>
      </div>

      {/* Legal Text */}
      <div className="bg-white rounded-2xl p-5 shadow-sm mb-6">
        <div className="space-y-4 text-sm text-gray-700 leading-relaxed">
          <p>
            أقر أنا، {userName}، بأنني قد اطلعت على كافة بنود العقد الموقع مع المحامي/ {lawyerName}، وأوافق عليها موافقة تامة ونافية للجهالة.
          </p>
          <p>
            أقر بأن هذا العقد الإلكتروني ومرفقاته يعتبر <strong style={{color: 'red'}}>سنداً تنفيذياً</strong> بموجب الأنظمة المعمول بها في المملكة العربية السعودية، وأن التوقيع الإلكتروني عبر هذه المنصة يعتبر توقيعاً ملزماً قانونياً.
          </p>
          <p>
            أتعهد بالالتزام بسداد كافة الدفعات المالية المجدولة في مواعيدها المحددة، وأقر بعلمي بأن عدم الالتزام بالسداد يمنح الطرف الآخر الحق في اتخاذ الإجراءات القانونية اللازمة دون إشعار مسبق.
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div>
        <div className="grid grid-cols-2 gap-4 max-w-md mx-auto">
          <button
            onClick={handleBack}
            style={{
              width: '100%',
              padding: '0.75rem',
              borderRadius: '0.75rem',
              backgroundColor: '#f3f4f6',
              color: '#4b5563',
              fontWeight: 500,
              border: '1px solid #e5e7eb',
            }}
          >
            رجوع
          </button>
          <button
            onClick={handleAgree}
            style={{
              width: '100%',
              padding: '0.75rem',
              borderRadius: '0.75rem',
              backgroundColor: 'oklch(0.55 0.24 262.91)',
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            أوافق وأتعهد
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContractAcknowledgmentPage;
